import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
declare const Chart: any;
declare const profilechart: any;
import Tagify from '@yaireo/tagify';

@Component({
  selector: 'app-userprofile',
  templateUrl: './userprofile.component.html',
  styleUrls: ['./userprofile.component.css']
})
export class UserprofileComponent implements OnInit {

    dropdownList = [];
    selectedItems = [];
    dropdownSettings = {};

  constructor() { }

  ngOnInit(): void {

  profilechart();

  var interest = document.querySelector('input[name=interest]'),
    tagify = new Tagify(interest, {
        pattern             : /^.{0,20}$/, 
        delimiters          : ",| ",
        keepInvalidTags     : true,         
        editTags            : 1,            
        maxTags             : 6,
        transformTag        : transformTag,
        backspace           : "edit",
        placeholder         : "Enter Interest Areas",
        dropdown : {
            enabled: 3,
        }
    })

function getRandomColor(){
    function rand(min, max) {
        return min + Math.random() * (max - min);
    }

    var h = rand(1, 360)|0,
        s = rand(40, 70)|0,
        l = rand(65, 72)|0;

    return 'hsl(' + h + ',' + s + '%,' + l + '%)';
}

function transformTag( tagData ){
    tagData.style = "--tag-bg:" + getRandomColor();

    if( tagData.value.toLowerCase() == 'shit' )
       tagData.value = 's✲✲t'
}

  this.dropdownList = [
                        {"id":1,"itemName":"Marketplace","value":"Marketplace"},
                        {"id":2,"itemName":"Exchange","value":"Exchange"},
                        {"id":3,"itemName":"Storage & Management","value":"Storage & Management"},
                        {"id":4,"itemName":"Measurements & Analytics","value":"Measurements & Analytics"},
                        {"id":5,"itemName":"Compliances","value":"Compliances"},
                        {"id":6,"itemName":"Personalization","value":"Personalization"},
                        {"id":7,"itemName":"AI & Machine Learning","value":"AI & Machine Learning"},
                        {"id":8,"itemName":"Research","value":"Research"},
                        {"id":9,"itemName":"Other","value":"Other"}
                      ];
    this.selectedItems=[
                        {"id":1,"itemName":"Marketplace","value":"Marketplace"},
                        {"id":2,"itemName":"Exchange","value":"Exchange"},
    ]
    this.dropdownSettings = { 
                              singleSelection: false, 
                              text:"Obejctives",
                              selectAllText:'Select All',
                              unSelectAllText:'UnSelect All',
                              enableSearchFilter: true,
                              classes:"myclass custom-class"
                            }; 




  $(".header-title p").text('Profile');

  $(".explore").click(function(){
  $(".dropdown-menu-anim-explore").removeClass("d-none").addClass("d-block");
   });

  $(document).mouseup(function(){
    $(".dropdown-menu-anim-explore").removeClass("d-block").addClass("d-none");
   });

  $(".today").click(function(){
    $(".dropdown-menu-anim-today").removeClass("d-none").addClass("d-block");
   });

  $(document).mouseup(function(){
    $(".dropdown-menu-anim-today").removeClass("d-block").addClass("d-none");
  });

    }

    onClick(event){
        $('#identify_document').trigger('click');
      }
    

}
